<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          前所属・経歴
        </SectionTitle>
        <router-link
          v-if="canEdit"
          :to="`/members/${userId}/profile/past_departments`"
          class="text-decoration-none">
          <icon-button
            class="ml-2"
            width="24"
            height="24"
            icon-size="18"
            icon="edit" />
        </router-link>
        <div
          v-if="pastDepartments[0]"
          class="ml-2 fs-s">
          更新日 {{ pastDepartments[0].updatedAt | prettyDate }}
        </div>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <PastDepartmentsForm
        v-if="pastDepartments.length > 0"
        :past-departments="pastDepartments"
        readonly />
    </b-collapse>
  </div>  
</template>

<script>
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import IconButton from '@/components/parts/IconButton.vue'
import PastDepartmentsForm from '@/components/view/profile/past_departments/PastDepartmentsForm.vue'

export default {
  components: {
    SectionTitle,
    CollapseButton,
    IconButton,
    PastDepartmentsForm
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true
    },
    pastDepartments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
}
</script>

<style>

</style>